import React from 'react';
import './Footer.css';
import { FaEnvelope, FaInstagram, FaXTwitter, FaApple, FaGooglePlay } from 'react-icons/fa6';
// ...existing code...
// ...existing code...

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-section">
          <h3>Contact Us</h3>
          {/* <div className="contact-item"> */}
          <ul>
            <li><a href="mailto:instapaw.official@gmail.com" target="_blank" rel="noopener noreferrer"><FaEnvelope className="footer-icon" />instapaw.official@gmail.com</a></li>
            <li><a href="https://www.instagram.com/instapaw.official/" target="_blank" rel="noopener noreferrer"><FaInstagram className="footer-icon" />Instapaw</a></li>
            <li><a href="https://x.com/instapaw_" target="_blank" rel="noopener noreferrer"><FaXTwitter className="footer-icon" />Instapaw</a></li>
		  </ul>
        {/* </div> */}
        </div>

        <div className="footer-section">
          <h3>Instapaw</h3>
          <ul>
          {/* <li><Link to="/story">Our Story</Link></li> */}
          <li><a href="/terms" target="_blank" rel="noopener noreferrer">Terms of Service</a></li>
          {/* <li><Link to="/story">Support Center</Link></li> */}
          <li><a href="/privacy" target="_blank" rel="noopener noreferrer">Privacy Policy</a></li>
          </ul>
        </div>
        <div className="footer-section">
        <h3>Download App</h3>
        <div className="download-icons">
        <p>Post, coordinate, follow updates, and help nearby animals faster.</p>
            <a href="https://apps.apple.com/in/app/instapaw/id6764773428" className="download-link" title="Download on the App Store" target="_blank" rel="noopener noreferrer">
              <span><FaApple className="app-icon" /> App Store</span>
            </a>
            <a href="https://play.google.com/store/apps/details?id=com.santoshbhatt.instapaw" className="download-link" title="Get it on Google Play" target="_blank" rel="noopener noreferrer">
            <span><FaGooglePlay className="app-icon" /> Google Play</span>
            </a>
        </div>
        </div>
      </div>
      

      <div className="footer-bottom">
        <p>&copy; {year} Instapaw. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
